const CFPB_KEY = 'Cfpb'
const PAYPAL_CASH_KEY = 'Cash'
const PAYPAL_CASH_PLUS_KEY = 'CashPlus'

/**
 * Returns the appropriate content key based on the conditions mentioned.
 * This function appends 'Cfpb' at the end of the param key if its
 * a US Personal or Premier account
 * Otherwise original key is returned
 * @param key
 * @param country
 * @param accountType
 * @returns {string}
 */
export function getCfpbContentKey(
  key: string,
  isCFPBEnabledCountry?: boolean,
  accountType?: string
) {
  let contentKey = key
  if (isCFPBEnabled(isCFPBEnabledCountry, accountType)) {
    contentKey = `${key}${CFPB_KEY}`
  }
  return contentKey
}

/**
 * Get the dynamic content based on Subscription Type of the user
 * Subscription Type can be 'PAYPAL_CASH' , 'PAYPAL_CASH_PLUS' , default is 'WALLET'
 * @param key
 * @param isCFPBEnabledCountry
 * @param accountType
 * @param subscriptionType
 * @returns {string}
 */
export function getCfpbDynamicContentKey(
  key: string,
  isCFPBEnabledCountry?: boolean,
  accountType?: string,
  subscriptionType?: string
) {
  let contentKey = key
  if (isCFPBEnabled(isCFPBEnabledCountry, accountType)) {
    contentKey = getCfpbContentKey(key, isCFPBEnabledCountry, accountType)
    switch (subscriptionType) {
      case 'PAYPAL_CASH':
        contentKey = `${contentKey}${PAYPAL_CASH_KEY}`
        break
      case 'PAYPAL_CASH_PLUS':
        contentKey = `${contentKey}${PAYPAL_CASH_PLUS_KEY}`
        break
      default:
        break
    }
  }
  return contentKey
}

/**
 * Check whether the account type is eligible for CFPB
 * Also check if the country is eligible for CFPB
 * @param isCFPBEnabledCountry
 * @param accountType
 * @returns {boolean|RegExpMatchArray}
 */
export function isCFPBEnabled(
  isCFPBEnabledCountry: boolean,
  accountType: string
) {
  const checkEligibility =
    accountType &&
    !!accountType.match(/^(PERSONAL|PREMIER)$/) &&
    isCFPBEnabledCountry

  return checkEligibility
}
